"use client";
import React from "react";
import { useCurrency } from "@/app/providers/currencyContext";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { useTranslations } from "next-intl";
import { Layout } from "@/dto/item";

interface SingleProductDescriptionFocusedPriceProps {
  product: any;
  isGiftCardProduct: boolean;
  layout?: Layout;
}

export const SingleProductDescriptionFocusedPrice = ({
  product,
  isGiftCardProduct,
  layout = "default",
}: SingleProductDescriptionFocusedPriceProps) => {
  const { format } = useCurrency();
  const t = useTranslations("SingleProductDescriptionFocusedPrice");
  const getPriceClassName = (): string => {
    if (layout === "enhanced") return "pt-[3px] text-base font-medium";

    return "pt-[3px] text-sm font-medium pl-3";
  };

  if (!product.available) {
    return (
      <span className="self-start pt-[2px] font-medium">{t("soldOut")}</span>
    );
  }

  return (
    <span
      data-testid={applyDataTestId(pom.products.productPrice)}
      className={getPriceClassName()}
    >
      {!isGiftCardProduct ? format(product.price) : t("customValue")}
    </span>
  );
};
